import { Info } from "lucide-react";

/**
 * InfoTip — an inline label with a hover definition, so users understand a term
 * or metric without leaving the screen. CSS-only tooltip (no provider needed).
 */
export const InfoTip = ({ label, tip, testid, className = "" }) => (
  <span className={`group relative inline-flex items-center gap-1 ${className}`}>
    {label}
    <Info size={12} className="cursor-help text-ek-ink/30 transition-colors group-hover:text-ek-purple" data-testid={testid} />
    <span
      role="tooltip"
      className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-1.5 w-56 -translate-x-1/2 rounded-md bg-ek-ink px-3 py-2 text-left text-xs font-normal normal-case leading-relaxed tracking-normal text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100"
    >
      {tip}
    </span>
  </span>
);
